<template lang="pug">
    cs-loader(v-if="!params")
    .game-info__individual-settings(v-else)
        multiplayer-tiny-setting.game-info__difficult(
            :label="`${currentDigitCapacityValue} Р`",
            :value="currentDigitCapacityValue",
            :min="difficulties[0].value",
            :max="difficulties[difficulties.length - 1].value",
            :disabled="!isGamePaused",
            @increase="handleDifficultyIncrease",
            @decrease="handleDifficultyDecrease",
        )
</template>

<script>
    import { mapState } from 'vuex';
    import { last } from 'lodash';

    const PARAMETERS_UPDATE_EVENT = 'parametersUpdate';

    export default {
        mounted() {
            this.parameters = this.paramsArray;
            this.params = this.paramsArray[this.currentUserPosition];
        },
        props: {
            currentUserPosition: {
                type: Number,
                default: 0,
            },
            isGamePaused: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            params: {
                handler(value, oldValue) {
                    if (oldValue !== null) {
                        this.parameters[this.currentUserPosition] = value;
                        this.$store.dispatch('setParamsArray', this.parameters);
                        this.$emit(PARAMETERS_UPDATE_EVENT);
                    }
                },
                deep: true,
            },
        },
        data() {
            return {
                parameters: null,
                params: null,
            };
        },
        methods: {
            handleDifficultyIncrease() {
                this.params.difficulties.push(last(this.params.difficulties) + 1);
            },
            handleDifficultyDecrease() {
                const difficultToRemove = this.params.difficulties.pop();
                if (this.params.difficulties.length === 0) {
                    this.params.difficulties.push(difficultToRemove - 1);
                }
            },
        },
        computed: {
            ...mapState({
                paramsArray: state => state.trainer.paramsArray,
            }),
            currentDigitCapacityValue() {
                if (this.params) {
                    return last(this.params.difficulties);
                }
                return 1;
            },
            difficulties() {
                const commonDifficulties = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    },
                ];
                const extraDifficulties = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                        value: 6,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: false,
                        value: 7,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: false,
                        value: 8,
                    },
                ];
                if (this.params.slug === 'RootsAndSquares') {
                    return commonDifficulties;
                }
                return [...commonDifficulties, ...extraDifficulties];
            },
        },
    };
</script>

<style scoped lang="scss">
    .game-info__individual-settings {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        align-self: center;
    }
</style>
